import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, IdDescription } from '../../../tms-shared';
import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SupplierReferenceService extends BaseReferenceService {
  constructor(protected httpService: HttpService) {
    super('SupplierReference', httpService);
  }

  get(): Observable<IdDescription[]> {
    console.log('A supplier search should be used instead of a dropdown');
    return super.get();
  }

  getShippers(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetShippers`);
  }

  getShippersKey(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetShippersKey`);
  }

  getAgents(): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetAgents`);
  }
}
